import { formatExportTitle } from "@/domain/export/formatExportTitle";
import { formatBytes } from "@/utils/format/bytes";
import { isUiMockMode } from "@/config/features";
import {
  MOCK_EXPORT_DISPLAY_TITLES,
  mockExportDisplayTitle,
  mockExportZipSize,
} from "@/fixtures/exportJobs";
import type { ExportJobDetail } from "@/types/api";

export function exportDisplayTitle(job: ExportJobDetail): string {
  if (isUiMockMode()) {
    const mockTitle = mockExportDisplayTitle(job);
    if (MOCK_EXPORT_DISPLAY_TITLES[job.job_id]) return mockTitle;
  }
  return formatExportTitle(job);
}

export function exportZipSizeLabel(job: ExportJobDetail): string {
  if (job.status !== "SUCCESS") return "—";
  if (isUiMockMode()) {
    return mockExportZipSize(job) ?? "—";
  }
  if (job.zip_size_bytes != null) {
    return formatBytes(job.zip_size_bytes);
  }
  return "—";
}

export function exportCreditsLabel(job: ExportJobDetail): string {
  if (isUiMockMode() && job.invoice_success_count > 0) {
    return String(job.invoice_success_count);
  }
  return "—";
}

export function formatProgressLabel(job: ExportJobDetail): string {
  if (job.status === "SUCCESS") return "100%";
  if (job.status === "FAILED" || job.status === "CANCELED") return "—";
  return `${Math.max(0, Math.min(100, job.progress_percent))}%`;
}
